module.exports = __webpack_public_path__ + "static/media/slice@2x.289f7e8c.png";